module.exports = __webpack_public_path__ + "static/media/clip-dark.a5d71408.svg";